/** Horizontal XP progress bar with level label. */
export function XpBar({ xp, xpToNext, level }) {
  const pct = Math.min((xp / xpToNext) * 100, 100);
  return (
    <div className="xp-bar-container">
      <div className="xp-bar-fill" style={{ width: `${pct}%` }} />
      <span className="xp-bar-label">Lv.{level} &nbsp;·&nbsp; {xp} / {xpToNext} XP</span>
    </div>
  );
}
